import { keepPreviousData } from "@tanstack/react-query";
import { trpc } from "../trpc";
import type { Member } from "@zapier/bff";

interface Input {
  search?: string;
  allowTeams?: boolean;
  /** When set, controls whether the query runs (e.g. only when a modal is open). When unset, falls back to !!allowTeams for backward compatibility. */
  enabled?: boolean;
  /** Search members on this account (e.g. parent org when sharing from a workspace). */
  accountId?: string;
}

export function useQuerySearchMembers({
  search,
  allowTeams,
  enabled: enabledProperty,
  accountId,
}: Input = {}) {
  const enabled =
    enabledProperty === undefined ? !!allowTeams : enabledProperty;
  const members = trpc.member.searchMembers.useQuery(
    { search, accountId },
    {
      placeholderData: keepPreviousData,
      enabled,
      trpc: {
        context: {
          skipBatching: true,
        },
      },
    },
  );

  return {
    members: members.data || ([] as Member[]),
    isLoading: members.isLoading,
    isFetching: members.isFetching,
  };
}
